import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { Col } from '../Col';
import { Image } from '../Image';
import { Row } from '../Row';
import styles from './PaymentLabel.module.scss';

type PaymentLabelProps = {
	image?: ReactNode;
};

export const PaymentLabel: FC<PaymentLabelProps> = ({ image, children }) => {
	return (
		<span className={classNames(styles.paymentLabel, 'd-flex mt-n1')}>
			<Row as="span" className="gy-2 gx-4">
				{image && (
					<Col as="span" xs={12} sm="auto">
						<Image className={classNames(styles.paymentLabelImage, 'position-relative')}>{image}</Image>
					</Col>
				)}
				<Col as="span" className="pt-1">
					{children}
				</Col>
			</Row>
		</span>
	);
};
